/**
 * Image Block JavaScript
 */

(function() {
    'use strict';

    function initImage() {
        const blocks = document.querySelectorAll('.image');
        blocks.forEach(function(block) {
            // Block initialized
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initImage);
    } else {
        initImage();
    }
})();